import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import FlowchartSettingsPane from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/DefaultTaskSchemaNodeFlowchartSettingsPane';
import InputOutputFieldsTab from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/InputOutputFieldsTab';
import TransitionFieldInfoTab from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/TransitionFieldInfoTab';

import {NodeSettingsTabKeys, SidepanelTab} from './processFlowchartConfigEditorConstants';

export const PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE: Partial<
  Record<ProcessFlowchartPlatformFeatureType, Array<SidepanelTab>>
> = {
  [ProcessFlowchartPlatformFeatureType.ALLOW_CONTROL_FLOW_TOKEN_CONFIGURATION]: [
    {
      key: NodeSettingsTabKeys.FLOWCHART_SETTINGS,
      label: 'Transitions',
      content: FlowchartSettingsPane,
    },
  ],
  [ProcessFlowchartPlatformFeatureType.ALLOW_FIELD_CONFIGURATION]: [
    {
      key: NodeSettingsTabKeys.INPUT_OUTPUT_FIELDS,
      label: 'Inputs & Outputs',
      content: InputOutputFieldsTab,
    },
    {
      key: NodeSettingsTabKeys.FIELD_MAPPING_INFO,
      label: 'Field Info',
      content: TransitionFieldInfoTab,
      openOnFieldSelect: true,
    },
  ],
} as const;
